import { ELocaleCode } from '@core/modules/intl/domain/enums';

export const dashboardViewI18n = {
	[ELocaleCode.RU_RU]: {
		today: 'Сегодня',
		leftover: 'Остаток',
		categories: 'Категории',
		venues: 'Места',
	},
	[ELocaleCode.EN_US]: {
		today: 'Today',
		leftover: 'Leftover',
		categories: 'Categories',
		venues: 'Venues',
	},
};
